<template>
  <article class="info-section">
    <div class="form-holder">
      <SectionHeading>Register</SectionHeading>
      <h2 class="registration-form-directions">To create your account and start tracking your collection fill out the form below.</h2>
      <transition name="fade" mode="out-in">
        <form-register v-if="!authenticated"></form-register>
        <div v-else>
          <h2 class="info-section-subheading">You have logged in successfully!</h2>
        </div>
      </transition>
    </div>
  </article>
</template>

<script>
import FormRegister from '../../components/FormRegisterUser/FormRegisterUser';
import SectionHeading from '../../components/SectionHeading/SectionHeading';

export default {
  name: 'RegisterPage',
  props: {
    authenticated: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    FormRegister,
    SectionHeading,
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/config';

.info-section {
  max-width: 700px;
  margin: 0 auto;
  padding-top: 2rem;
}

.section-heading {
  text-align: left;
}

.form-holder {
  margin-top: 3rem;
}

.registration-form-directions {
  font-size: 1rem;
  color: $secondary-color;
  margin: auto;
  font-weight: bold;
}
</style>
